import { render } from "./Productos.vue?vue&type=template&id=406541ce&scoped=true"
import script from "./Productos.vue?vue&type=script&lang=js"
export * from "./Productos.vue?vue&type=script&lang=js"

import "./Productos.vue?vue&type=style&index=0&id=406541ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406541ce"]])

export default __exports__